define([
    "dojo/_base/declare",
    "csi",
    "csi/_base/underscore",
    "csi/heading/AttributeController",
    "csi/image/_base",
    "csi/reflection",
    "csi/xml"
], function(declare,csi,_,AttributeController,csiImage,reflection,xml) {

	return declare(AttributeController, {
		_toWriterValue: function(/*String*/id, /*String*/type) {
			// summary: if key is default, then reset to next available image; if key is label, then reset to empty
			var	cn = this.m_writer.changeNode(this.m_urlNode);
			if (type == xml.ATTR_REF) {
				cn.changeAttribute(id, xml.ATTR_REF, csi.EMPTY_URL);
				return;
			}

			var	images = this.getNode()[id];
			var urlImage = images[this.keyContainer];
			var	keysToRemove = [];

			_.each(images, function(value, key) {
				if (value == urlImage) {
					keysToRemove.push(key);
				}
			});

			cn.removeAttributeKeys(id, type, keysToRemove);

			// if removing default image, then set to next numbered key
			if (images[reflection.DEFAULT_IMAGE_LABEL] == urlImage) {
				var	key = csiImage.getFirstKey(images, true);
				if (key) {
					cn.changeAttributeKeys(id, type, csi.objectNew(reflection.DEFAULT_IMAGE_LABEL, images[key]));
				}
			}

			// reset index so that when heading is refreshed it does not apply single index to DOM when rendering for all images
			this._ctx.keyValue = null;

			return cn;
		}
	});
});